// Custom Product Card JavaScript - Add to theme.liquid before closing </body>

class CBHQuickView {
  constructor() {
    this.popup = null
    this.currentProduct = null
    this.currentSlide = 0
    this.selectedVariant = null
    this.init()
  }

  init() {
    this.popup = document.getElementById("cbh-quick-view-popup")
    this.bindEvents()
  }

  bindEvents() {
    // Quick view button clicks
    document.addEventListener("click", (e) => {
      if (e.target.classList.contains("cbh-product-card-quick-view-btn")) {
        e.preventDefault()
        const productHandle = e.target.dataset.productHandle
        this.openQuickView(productHandle)
      }
    })

    // Close popup
    if (this.popup) {
      this.popup.querySelector(".cbh-quick-view-popup-close").addEventListener("click", () => {
        this.closeQuickView()
      })

      document.getElementById("cbh-popup-overlay").addEventListener("click", (e) => {
        if (e.target.id === "cbh-popup-overlay") {
          this.closeQuickView()
        }
      })

      // Slider navigation
      this.popup.querySelector(".cbh-quick-view-popup-prev").addEventListener("click", () => {
        this.prevSlide()
      })

      this.popup.querySelector(".cbh-quick-view-popup-next").addEventListener("click", () => {
        this.nextSlide()
      })

      // Form submission
      this.popup.querySelector(".cbh-quick-view-popup-form").addEventListener("submit", (e) => {
        e.preventDefault()
        this.addToCart()
      })
    }

    // ESC key to close
    document.addEventListener("keydown", (e) => {
      if (
        e.key === "Escape" &&
        this.popup &&
        document.getElementById("cbh-popup-overlay").classList.contains("cbh-active")
      ) {
        this.closeQuickView()
      }
    })
  }

  async openQuickView(productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}.js`)
      const product = await response.json()
      this.currentProduct = product
      this.selectedVariant = product.variants[0]
      this.renderPopup(product)
      document.getElementById("cbh-popup-overlay").classList.add("cbh-active")
      document.body.style.overflow = "hidden"
    } catch (error) {
      console.error("Error loading product:", error)
    }
  }

  closeQuickView() {
    document.getElementById("cbh-popup-overlay").classList.remove("cbh-active")
    document.body.style.overflow = ""
    this.currentProduct = null
    this.selectedVariant = null
    this.currentSlide = 0
  }

  renderPopup(product) {
    // Update title and price
    this.popup.querySelector(".cbh-quick-view-popup-title").textContent = product.title
    this.popup.querySelector(".cbh-quick-view-popup-price").innerHTML = this.formatPrice(this.selectedVariant.price)

    // Update details link
    this.popup.querySelector(".cbh-quick-view-popup-details-link").href = `/products/${product.handle}`

    // Render images
    this.renderSlider(product.images)

    // Render variants
    this.renderVariants(product)

    this.updateAddToCartButton()
  }

  renderSlider(images) {
    const slidesContainer = this.popup.querySelector(".cbh-quick-view-popup-slides")
    slidesContainer.innerHTML = ""

    this.currentSlide = 0

    images.forEach((image, index) => {
      const slide = document.createElement("div")
      slide.className = `cbh-quick-view-popup-slide ${index >= 2 ? "hidden" : ""}`
      slide.innerHTML = `<img src="${image}" alt="Product image ${index + 1}">`
      slidesContainer.appendChild(slide)
    })

    // Show/hide navigation based on image count
    const navButtons = this.popup.querySelectorAll(".cbh-quick-view-popup-nav")
    navButtons.forEach((btn) => {
      btn.style.display = images.length > 2 ? "flex" : "none"
    })
  }

  renderVariants(product) {
    const variantsContainer = this.popup.querySelector(".cbh-quick-view-popup-variants")
    variantsContainer.innerHTML = ""

    if (product.options && product.options.length > 0) {
      product.options.forEach((option, optionIndex) => {
        const variantGroup = document.createElement("div")
        variantGroup.className = "cbh-quick-view-popup-variant-group"

        const label = document.createElement("div")
        label.className = "cbh-quick-view-popup-variant-label"
        label.textContent = option.name

        const optionsContainer = document.createElement("div")
        optionsContainer.className = "cbh-quick-view-popup-variant-options"

        option.values.forEach((value) => {
          const optionBtn = document.createElement("button")
          optionBtn.type = "button"
          optionBtn.className = "cbh-quick-view-popup-variant-option"
          optionBtn.textContent = value
          optionBtn.dataset.optionIndex = optionIndex
          optionBtn.dataset.value = value

          const variantWithOption = this.currentProduct.variants.find(
            (variant) => variant.options[optionIndex] === value,
          )
          if (!variantWithOption || !variantWithOption.available) {
            optionBtn.classList.add("unavailable")
            optionBtn.disabled = true
          }

          // Check if this is the selected variant
          if (this.selectedVariant.options[optionIndex] === value) {
            optionBtn.classList.add("selected")
          }

          optionBtn.addEventListener("click", () => {
            if (!optionBtn.disabled) {
              this.selectVariantOption(optionIndex, value)
            }
          })

          optionsContainer.appendChild(optionBtn)
        })

        variantGroup.appendChild(label)
        variantGroup.appendChild(optionsContainer)
        variantsContainer.appendChild(variantGroup)
      })
    }
  }

  selectVariantOption(optionIndex, value) {
    // Update selected options
    const newOptions = [...this.selectedVariant.options]
    newOptions[optionIndex] = value

    // Find matching variant
    const matchingVariant = this.currentProduct.variants.find((variant) =>
      variant.options.every((option, index) => option === newOptions[index]),
    )

    if (matchingVariant) {
      this.selectedVariant = matchingVariant

      this.popup.querySelector(".cbh-quick-view-popup-price").innerHTML = this.formatPrice(matchingVariant.price)

      // Update selected buttons
      this.popup.querySelectorAll(".cbh-quick-view-popup-variant-option").forEach((btn) => {
        btn.classList.remove("selected")
      })

      this.popup.querySelectorAll(`[data-option-index="${optionIndex}"][data-value="${value}"]`).forEach((btn) => {
        btn.classList.add("selected")
      })

      this.updateAddToCartButton()
    }
  }

  updateAddToCartButton() {
    const addToCartBtn = this.popup.querySelector(".cbh-quick-view-popup-add-to-cart")
    if (!this.selectedVariant.available) {
      addToCartBtn.disabled = true
      addToCartBtn.classList.add("sold-out")
      addToCartBtn.textContent = "Sold out"
    } else {
      addToCartBtn.disabled = false
      addToCartBtn.classList.remove("sold-out")
      addToCartBtn.textContent = "🛒 Add to cart"
    }
  }

  prevSlide() {
    const slides = this.popup.querySelectorAll(".cbh-quick-view-popup-slide")
    if (slides.length <= 2) return

    slides.forEach((slide) => slide.classList.add("hidden"))

    // Move to previous pair
    this.currentSlide = this.currentSlide <= 0 ? Math.max(0, slides.length - 2) : this.currentSlide - 2

    if (this.currentSlide < 0) this.currentSlide = 0

    // Show current pair
    for (let i = this.currentSlide; i < Math.min(this.currentSlide + 2, slides.length); i++) {
      slides[i].classList.remove("hidden")
    }
  }

  nextSlide() {
    const slides = this.popup.querySelectorAll(".cbh-quick-view-popup-slide")
    if (slides.length <= 2) return

    slides.forEach((slide) => slide.classList.add("hidden"))

    // Move to next pair
    this.currentSlide = this.currentSlide + 2 >= slides.length ? 0 : this.currentSlide + 2

    // Show current pair
    for (let i = this.currentSlide; i < Math.min(this.currentSlide + 2, slides.length); i++) {
      slides[i].classList.remove("hidden")
    }
  }

  async addToCart() {
    if (!this.selectedVariant || !this.selectedVariant.available) return

    const quantity = Number.parseInt(this.popup.querySelector("#cbh-popup-quantity").value)
    const addToCartBtn = this.popup.querySelector(".cbh-quick-view-popup-add-to-cart")

    addToCartBtn.disabled = true
    addToCartBtn.textContent = "Adding..."

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: this.selectedVariant.id,
          quantity: quantity,
        }),
      })

      if (response.ok) {
        // Success - you can trigger cart drawer or show success message
        addToCartBtn.textContent = "Added! ✓"
        setTimeout(() => {
          this.closeQuickView()
          // Trigger cart update event if you have cart drawer
          document.dispatchEvent(new CustomEvent("cart:updated"))
        }, 1000)
      } else {
        throw new Error("Failed to add to cart")
      }
    } catch (error) {
      console.error("Error adding to cart:", error)
      addToCartBtn.textContent = "Error - Try again"
    } finally {
      setTimeout(() => {
        addToCartBtn.disabled = false
        addToCartBtn.textContent = "🛒 Add to cart"
      }, 2000)
    }
  }

  formatPrice(price) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EUR",
    }).format(price / 100)
  }
}

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new CBHQuickView()
})
